import { auth } from "../firebase";

/**
 * Mensaje estándar cuando un usuario en modo demo intenta una operación de escritura.
 */
export const DEMO_BLOCK_MESSAGE =
  "Tu usuario está configurado en modo demo. No es posible realizar esta operación.";

/**
 * Indica si el usuario autenticado tiene el custom claim `habitia_demo`.
 * Las reglas de Firestore bloquean las escrituras para estos usuarios; este
 * helper permite detectarlo en el cliente y mostrar un mensaje claro en vez
 * del error crudo "Missing or insufficient permissions".
 *
 * @returns {Promise<boolean>} true si el usuario está en modo demo.
 */
export async function isDemoUser() {
  try {
    const user = auth.currentUser;
    if (!user) return false;
    // Forzar refresh (true): el token cacheado puede estar desincronizado del
    // que Firestore realmente envía, lo que provoca que el guard pase pero la
    // regla rechace con "permission-denied". Con refresh leemos el claim real.
    const tokenResult = await user.getIdTokenResult(true);
    return tokenResult.claims.habitia_demo === true;
  } catch {
    // Si no se pueden leer los claims, no bloqueamos: que decidan las reglas.
    return false;
  }
}
